yes <template>
    <div>
        <div class="list-page remove-buffer">
            <div class="general-title">
                <div class="title">Browse Resources</div>
                <div class="buttons-container buttons">
                    <a v-if="hasFilters" href @click.prevent="clearFilters" class="neutral-bg">Clear Filters<span class="fa fa-sync"></span></a>
                    <a href @click.prevent="showFilters = !showFilters" class="neutral-bg">{{ showFilters ? 'Hide' : 'Show'}} Filters<span class="fa" :class="showFilters ? 'fa-angle-up' : 'fa-angle-down'"></span></a>
                </div>
            </div>
            <div v-if="showFilters" class="input-container">
                <div class="input-title">Filter By Categories</div>
                <div class="input-box">
                    <selectize v-model="categoryFilters" name="categories" placeholder="Select Categories" multiple>
                        <option v-for="category in categories" :key="category.id" :value="category.slug">{{ category.name }}</option>
                    </selectize>
                </div>
            </div>
            <div class="input-container">
                <div class="input-box"><input type="text" v-model="search" placeholder="Quick Search Resources"><span class="fa fa-search"></span></div>
            </div>
        </div>

        <div class="list-page">
            <a :href="`/resources/${ resource.slug }`" v-for="resource in filtered" :key="`resource-${ resource.id }`" class="resources-list">
                <div class="left">
                    <div class="date">{{ date(resource.date) }}</div>
                    <div class="headline">{{ resource.title }}</div>
                    <div v-for="category in resource.categories" :key="`${ resource.id }-${ category.id }`" class="resources-category-tag">{{ category.name }}</div>
                </div>
                <div v-if="!!resource.photo_filename" class="right"><img :src="`${ resource.photo_filepath }1000.${ resource.photo_filename }`"></div>
            </a>
        </div>
    </div>
</template>

<script>

import moment from 'moment';
import _ from 'underscore';

export default {

    props: [ 'resources', 'categories' ],

    data() {
        return {
            search: '',
            showFilters: false,
            categoryFilters: [],
        };
    },

    computed: {

        filtered() {
            let filtered = this.resources;
            if (this.search && this.search.length > 0) {
                // Search Filter
                const search = this.search.toLowerCase();
                filtered = _.filter(filtered, resource => resource.title.toLowerCase().indexOf(search) !== -1 ||
                    resource.text.toLowerCase().indexOf(search) !== -1
                );
            }

            if (this.categoryFilters.length > 0) {
                // Categories Filter
                filtered = _.filter(filtered, resource => {
                    console.log('filtering categories', _.difference(this.categoryFilters, _.pluck(resource.categories, 'id')));
                    return _.difference(this.categoryFilters, _.pluck(resource.categories, 'slug')).length === 0
                });
            }

            return filtered;
        },

        hasFilters() {
            return (
                (this.search && this.search.length > 0)
                || this.categoryFilters.length > 0
            );
        }

    },

    watch: {

        search() {
            this.updateUrl();
        },

        categoryFilters() {
            this.updateUrl();
        }

    },

    mounted() {
        var urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('search')) {
            this.search = urlParams.get('search');
        }

        if (urlParams.has('filters')) {
            this.categoryFilters = urlParams.get('filters').split('|');
        }

        console.log('get', urlParams.get('search'));
        for (var p of urlParams.entries()) {
            console.log(p);
        }

        if (this.categoryFilters.length > 0) {
            this.showFilters = true;
        }
    },

    methods: {

        date(date) {
            return moment(date).format('MMMM D, YYYY');
        },

        clearFilters() {
            this.search = '';
            this.categoryFilters = [];
        },

        updateUrl() {
            let urlParts = [
                '/resources?filters=',
                this.categoryFilters.join('|'),
                '&search=',
                this.search
            ];
            history.replaceState({}, 'ChildBe | Resources', urlParts.join(''));
        }
    }

}

</script>



// WEBPACK FOOTER //
// resources/js/components/resources/ResourceList.vue